import { Action, createReducer } from '@lib/plugin-redux-core';
import {
  GET_CLASS_STUDENT_USE_CASE,
  GET_CLASS_STUDENT_OVERVIEW_USE_CASE,
  LIST_CLASS_STUDENT_ASSIGNMENTS_USE_CASE,
} from '@module/class';

import { ClassStudentDetailState, empty } from './class-student.state';
export type { ClassStudentDetailState } from './class-student.state';
const initialState: ClassStudentDetailState = {
  membership: empty(),
  overview: empty(),
  assignments: empty(),
};
const resource = (name: string, field: keyof ClassStudentDetailState) => ({
  name,
  executing: (state: ClassStudentDetailState, action: Action) => {
    const more = field === 'assignments' && !!action.payload.filters?.nextToken;
    return {
      ...state,
      [field]: {
        ...state[field],
        data: more ? state[field].data : null,
        loading: !more,
        loadingMore: more,
        error: null,
        requestId: action.payload.requestId,
      },
    };
  },
  success: (state: ClassStudentDetailState, action: Action) => {
    if (state[field].requestId !== action.meta?.input?.requestId) return state;
    let data = action.payload;
    if (field === 'assignments' && action.meta?.input?.filters?.nextToken) {
      data = {
        ...data,
        items: [
          ...new Map(
            [...(state.assignments.data?.items ?? []), ...data.items].map((item) => [
              item.assignment.id,
              item,
            ]),
          ).values(),
        ],
      };
    }
    return {
      ...state,
      [field]: { ...state[field], data, loading: false, loadingMore: false, error: null },
    };
  },
  error: (state: ClassStudentDetailState, action: Action) => {
    if (state[field].requestId !== action.meta?.input?.requestId) return state;
    const error = action.error?.error;
    return {
      ...state,
      [field]: {
        ...state[field],
        loading: false,
        loadingMore: false,
        error: String(
          error instanceof Error ? error.message : (error ?? 'Could not load student data.'),
        ),
      },
    };
  },
  reset: (state: ClassStudentDetailState) => ({ ...state, [field]: empty() }),
});
export const classStudentDetailReducer = createReducer(initialState, [
  resource(GET_CLASS_STUDENT_USE_CASE, 'membership'),
  resource(GET_CLASS_STUDENT_OVERVIEW_USE_CASE, 'overview'),
  resource(LIST_CLASS_STUDENT_ASSIGNMENTS_USE_CASE, 'assignments'),
]);
